export const encodeRouteParam = (value: string | number | null | undefined) =>
    encodeURIComponent(String(value ?? ""));

export const decodeRouteParam = (value: string | undefined) => {
    if (!value) return "";

    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};
